import { configureStore, createSerializableStateInvariantMiddleware } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";

// import { applyMiddleware, compose } from 'redux';

import { useDispatch, useSelector } from "react-redux";
import apiCallMiddleware from "./apiCallMiddleware";
import payloadMiddleware from "./payloadMiddleware";

import rootReducer, {
  createReduxHistory,
  routerMiddleWare,
} from "./rootReducer";

const serializableMiddleware = createSerializableStateInvariantMiddleware(
  {
    ignoredActionPaths: ["apiCall"], // Important: ignore the apiCall property
  },
);

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk).concat(routerMiddleWare)
    .concat(payloadMiddleware)
    .concat(apiCallMiddleware)
    .concat(serializableMiddleware),
});

export const history = createReduxHistory(store);
export type AppStore = typeof store
export type RootState = ReturnType<AppStore["getState"]>
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore["dispatch"]

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export default store;
